export default "__VITE_ASSET__BzS7jifq__"